import * as D from '../deps';

import * as DesktopWorkers from './workers';

export default [
  {
    actionType: D.DesktopAppConstants.desktopActions.GENERATE_AND_GO_TO_BRANCH_LINK,
    handler: DesktopWorkers.generateAndGotoBranchLink,
    concur: 'takeLatest',
  },
];
